import { render, staticRenderFns } from "./FooterNew.vue?vue&type=template&id=cd8a673e&scoped=true&"
import script from "./FooterNew.vue?vue&type=script&lang=js&"
export * from "./FooterNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8a673e",
  null
  
)

export default component.exports